<div class="row">
  <div class="col-xl-6 col-md-6">
    <div class="card">
      <!--GESTION AGENTE-->
      <div class="card-header">
        <h3>{{ "recintos.crearreserva" | translate }}</h3>
      </div>
      <div class="card-body">
        <div class="form-group">
          <label>Título</label>
          <div class="caja">
            <!--Titulo-->
            <kendo-textbox
              placeholder="{{ 'recintos.ph_titulo_reserva' | translate }}"
              [clearButton]="true"
              [(ngModel)]="titulo"
            >
              <ng-template kendoTextBoxPrefixTemplate> </ng-template>
            </kendo-textbox>
          </div>
        </div>
        <!--Cuerpo-->
        <div class="form-group">
          <kendo-label text="{{ 'recintos.descripcion_reserva' | translate }}">
            <textarea
              kendoTextArea
              style="resize: none"
              rows="5"
              [(ngModel)]="descripcion"
            >
            </textarea>
          </kendo-label>
        </div>
        <!-- Fechas Reserva-->
        <div class="form-group">
          <kendo-label
            class="k-checkbox-label"
            text="{{ 'recintos.fechainicio' | translate }}"
          ></kendo-label>
          <div class="caja">
            <kendo-datetimepicker [(value)]="fechaInicio">
            </kendo-datetimepicker>
            <kendo-datetimepicker [(value)]="fechaFin"> </kendo-datetimepicker>
          </div>
        </div>
        <!-- Selección Usuario Reserva-->
        <kendo-label
        class="k-checkbox-label"
        text="{{ 'recintos.selectuser' | translate }}"
      ></kendo-label>
        <zitu-selector-usuarios
        (listaUsuarios)="getUsuariosSeleccionados($event)"
      >
      </zitu-selector-usuarios>
        <!-- DropDown usuarios-->

        <!-- Traducciones -->
        <div class="form-group">
          <!--Boton Publicar-->
          <button
            type="button"
            class="btn btn-success btn-sm mr-1"
            (click)="btnCrearReserva()"
          >
            {{ "recintos.reservar" | translate }}
          </button>
          <button
            type="button"
            class="btn btn-danger btn-sm mr-1"
            (click)="btnCancelar()"
          >
            {{ "botones.cancelar" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
